<template>
  <div class="profile-picture-wrapper">
    <div
      class="image profile-picture is-flex is-justify-content-center is-align-items-center is-clipped is-relative"
      :class="{ 'is-clickable': !onlyVisual }"
      @click="!onlyVisual && openFilePicker()"
    >
      <div
        v-if="!currentPhoto"
        class="is-flex is-flex-direction-column is-align-items-center"
      >
        <AddPhotoIcon />
        <div
          class="has-text-weigth-semibold px-2 has-text-centered is-hidden-mobile"
        >
          Adicione uma foto
        </div>
      </div>

      <template v-else>
        <img :src="currentPhoto" alt="" class="is-rounded" />
        <div v-if="!onlyVisual" class="photo-hover-overlay">
          <EditPhotoIcon />
        </div>
      </template>

      <input
        v-if="!onlyVisual"
        ref="fileInputRef"
        style="display: none"
        type="file"
        accept="image/*"
        @change="onFileSelected"
      />
    </div>

    <div v-if="currentPhoto && !onlyVisual" class="has-text-centered mt-2">
      <a
        class="has-text-danger is-size-7 is-clickable"
        @click.prevent="confirmRemove = true"
      >
        Remover foto
      </a>
    </div>

    <ProfilePictureCropperModal
      v-if="!onlyVisual && cropperSrc"
      :src="cropperSrc"
      @close="cropperSrc = null"
    />

    <ConfirmModal
      v-if="!onlyVisual && confirmRemove"
      title="Remover foto de perfil"
      message="Tem certeza que deseja remover sua foto de perfil?"
      :is-loading="isLoading"
      @close="confirmRemove = false"
      @confirm="submitRemove"
    />

  </div>
</template>

<script>
import { ref } from "vue";
import AddPhotoIcon from "icons/cached/add_a_photo.svg";
import EditPhotoIcon from "icons/cached/edit.svg";
import ProfilePictureCropperModal from "./ProfilePictureCropperModal.vue";
import ConfirmModal from "components/Crm/customer_modal/ConfirmModal.vue";

export default {
  components: {
    AddPhotoIcon,
    EditPhotoIcon,
    ProfilePictureCropperModal,
    ConfirmModal,
  },

  props: {
    initialPhoto: String,
    currentPhoto: String,
    onlyVisual: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const fileInputRef = ref(null);
    const currentPhoto = ref(props.currentPhoto || props.initialPhoto || null);
    const cropperSrc = ref(null);
    const confirmRemove = ref(false);
    const isLoading = ref(false);

    const csrfToken =
      document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";

    const openFilePicker = () => {
      fileInputRef.value?.click();
    };

    const onFileSelected = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (ev) => {
        cropperSrc.value = ev.target.result;
      };
      reader.readAsDataURL(file);

      e.target.value = "";
    };

    const submitRemove = () => {
      isLoading.value = true;
      const form = document.createElement("form");
      form.method = "post";
      form.action = "/users/avatar";

      const methodInput = document.createElement("input");
      methodInput.type = "hidden";
      methodInput.name = "_method";
      methodInput.value = "delete";
      form.appendChild(methodInput);

      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);

      document.body.appendChild(form);
      form.submit();
    };

    return {
      fileInputRef,
      currentPhoto,
      cropperSrc,
      confirmRemove,
      isLoading,
      onlyVisual: props.onlyVisual,
      openFilePicker,
      onFileSelected,
      submitRemove,
    };
  },
};
</script>

<style scoped>
.profile-picture-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-picture {
  position: relative;
}

.photo-hover-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0);
  transition: background 0.2s;
  fill: transparent;
}

.profile-picture:hover .photo-hover-overlay {
  background: rgba(0, 0, 0, 0.35);
  fill: #fff;
}
</style>
